import { z } from "zod";

import { system, SubmissionNS, TeamNS } from "@smart/bridge-types-basic";
import { buildSNSSQSDef } from "@smart/itops-constructs-basic";
import { buildNamespace } from "@smart/itops-types-basic";
import { wrapSchema } from "@smart/itops-utils-basic";

const AutoReminderNS = buildNamespace({
  system,
  entity: "AutoReminder",
} as const);

export const AutoReminderSchema = z.object({
  operationId: z.string(),
  submissionUri: SubmissionNS.schema,
  teamUri: TeamNS.schema,
  automaticCount: z.number(),
});

const AutoReminderGuard = wrapSchema(AutoReminderSchema);

export const AutoReminderDef = buildSNSSQSDef({
  namespace: AutoReminderNS,
  guard: AutoReminderGuard,
  sqsOnly: false,
  groupKey: "submissionUri",
  idKey: "operationId",
  maxAttempts: 1,
  visibilityTimeout: 60,
});
